const menuItems = {
  items: [
    {
      id: 'employee',
      title: 'Employee',
      type: 'group',    
      backIcon :'fa fa-chevron-left',  
      backUrl : '/',
      children: [
        {
          id: 'personal',
          title: 'Personal',
          type: 'item',
          url: '/employee/personal',
          icon: 'fa fa-user-circle',          
        },
        {
          id: 'job',
          title: 'Job',
          type: 'item',
          url: '/employee/job',
          icon: 'fa fa-tasks',          
        },
        {
          id: 'education',
          title: 'Employment & Education',
          type: 'item',
          url: '/employee/education',
          classes: 'nav-item',
          icon: 'fa fa-user-graduate',
        },
        {
          id: 'compensation',
          title: 'Compensation',
          type: 'item',
          url: '/employee/compensation',
          classes: 'nav-item',
          icon: 'fa fa-money-bill',
        },                  
        {
          id: 'timeoff',
          title: 'Timeoff',
          type: 'item',
          url: '/employee/timeoff',
          icon: 'fa fa-calendar-day',          
        },        
        {
          id: 'files',
          title: 'Files',
          type: 'item',
          url: '/employee/files',
          icon: 'fa fa-folder',
        }, 
        {
          id: 'private-note',
          title: 'Private Note',
          type: 'item',
          url: '/employee/private-note',
          icon: 'fa fa-sticky-note',
        },  
        {
          id: 'timeline',
          title: 'Timeline',
          type: 'item',
          url: '/employee/timeline',
          icon: 'fa fa-stream',
        }, 
        {
          id: 'benefit',
          title: 'Benefit',
          type: 'item',
          url: '/employee/benefit',
          icon: 'fa fa-trophy',
        },                                    
      ],
    },    
  ],
}

export default menuItems
